import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Button, Grid, Typography } from '@mui/material'

import { ScreenWrapper } from '../../components/ScreenWrapper'
import { Path } from '../../router/BaseRouter/enums'

export const NotFound: FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <ScreenWrapper title="">
      <Grid container justifyContent="center" sx={{ mt: 4 }}>
        <Grid item xs={12}>
          <Grid container justifyContent="center">
            <Typography variant="h3">404</Typography>
          </Grid>
        </Grid>
        <Grid item xs={12} sx={{ mt: 2 }}>
          <Grid container justifyContent="center">
            <Typography variant="h5">{t('notFound.title')}</Typography>
          </Grid>
        </Grid>
        <Grid item xs={12} sx={{ mt: 3 }}>
          <Grid container justifyContent="center">
            <Button color="primary" variant="contained" onClick={() => navigate(Path.HOME)}>
              {t('general.button.backToHomepage')}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </ScreenWrapper>
  )
}
